import VueTypes from './shim'
Object.defineProperty(exports, '__esModule', {
  value: true,
})

export default VueTypes

export * from './shim'
